const SET_SELECTED_ITEMS = 'SET_SELECTED_ITEMS';
const SET_SELECTED_ROW = 'SET_SELECTED_ROW';

export default {
  namespaced: true,
  state: {
    selectedItems: [],
    selectedRow: null
  },
  mutations: {
    [SET_SELECTED_ITEMS](state, items) {
      state.selectedItems = items;
    },
    [SET_SELECTED_ROW](state, row) {
      if (
        (state.selectedRow &&
          state.selectedRow.leadColumn.id === row?.leadColumn.id) ||
        !row
      ) {
        state.selectedRow = null;
      } else {
        state.selectedRow = row;
      }
    }
  },
  actions: {
    setSelectedItemsAction({ commit }, items) {
      commit(SET_SELECTED_ITEMS, items);
    },
    setSelectedRowAction({ commit }, row) {
      commit(SET_SELECTED_ROW, row);
    }
  },
  getters: {
    getCurrentOpenCard(state) {
      if (state.selectedRow) {
        return state.selectedRow;
      } else {
        return state.selectedItems[state.selectedItems.length - 1];
      }
    }
  }
};
